import SimpleLine from "../simpleLine";
import NumberText from "../../workspace/text/numberText";
import {COLORS} from "../../../../../../../colorThemes";
import workspace from "../../workspace";
import sqftEventManager from "../../../store/sqftEventManager";
import EventManager from "../../../store/sqftEventManager";

class LineImage extends SimpleLine {
  constructor(from, to, parent, lineIndex) {
    super(from, to, parent)

    this.movableImage = parent;
    this.lineIndex = lineIndex;
    const design = {fontColor: COLORS.red, eventsPriority: sqftEventManager.priorities.IMAGE_LINE};
    let xOffset = 0;
    let yOffset = 0;
    switch (lineIndex) {
      case 0:
        xOffset = 0;
        yOffset = 15;
        break;
      case 1:
        xOffset = 0;
        yOffset = -15;
        break;
      case 2:
        xOffset = 0;
        yOffset = 15;
        break;
      case 3:
        xOffset = 0;
        yOffset = 15;
        break;
    }
    // const xOffset = lineIndex === 0 || lineIndex === 2 ? 0 : 15;
    // const yOffset = lineIndex === 0 || lineIndex === 2 ? 15 : 0;
    this.measurementInsideShape = new NumberText(0, {xOffset: xOffset, yOffset}, design, workspace, this.updatePosInsideShape, false);
  }

  destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      this.from.destroy(protect);
      this.lineLengthText.destroy();
      this.measurementInsideShape.destroy();
    }
  };

  deregisterEvents = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      this.isHidden = true;
      this.from.deregisterEvents();
      this.lineLengthText.deregisterEvents();
      this.measurementInsideShape.deregisterEvents();
    }
  };

  reInitEvents = () => {
    if (this.isHidden) {
      this.initEvents();
      this.isHidden = false;

      this.from.reInitEvents();
      this.lineLengthText.reInitEvents();
      this.measurementInsideShape.reInitEvents();
    }
  }

  updatePosInsideShape = (val, numberText, prevValue) => {
    const diff = prevValue - val;
    const angleInRadians = this.movableImage.rotatedDegrees * Math.PI / 180; // Предполагая, что rotationAngle - это угол вращения в градусах

    // Calculate the offset taking into account the rotation angle
    const deltaX = diff * Math.cos(angleInRadians);
    const deltaY = diff * Math.sin(angleInRadians);

    const movableImage = this.from.parent;
    const lineIndex = this.lineIndex;
    let posXDiff = 0;
    let posYDiff = 0;
    switch (lineIndex) {
      case 0:
        posXDiff = -deltaY;
        posYDiff = -deltaX;
        break;
      case 1:
        posXDiff = +deltaX;
        posYDiff = +deltaY;
        break;
      case 2:
        posXDiff = +deltaY;
        posYDiff = +deltaX;
        break;
      case 3:
        posXDiff = -deltaX;
        posYDiff = -deltaY;
        break;
    }

    movableImage.setPosition({x: movableImage.pos.x + posXDiff, y: movableImage.pos.y + posYDiff});
  };

}

export default LineImage;
